/**
 * The nine §5.2 master-list types and their display labels, and the §5.2
 * section enum (procedure/fee entries) — Admin tab, master lists section
 * (plan §11 tab 6, §13.4 WP-33b).
 */
import type { MasterListType, MasterListSection } from '../../../api/client';

export const MASTER_LIST_TYPE_OPTIONS: Array<{ value: MasterListType; label: string }> = [
  { value: 'sponsor', label: 'Sponsor' },
  { value: 'cro', label: 'CRO' },
  { value: 'therapeutic_area', label: 'Therapeutic area' },
  { value: 'indication', label: 'Indication' },
  { value: 'procedure', label: 'Procedure' },
  { value: 'fee', label: 'Fee' },
  { value: 'payment_agent', label: 'Payment agent' },
  { value: 'entity', label: 'Entity' },
  { value: 'site_alias', label: 'Site alias' },
];

export const MASTER_LIST_TYPE_LABEL: Record<MasterListType, string> = MASTER_LIST_TYPE_OPTIONS.reduce(
  (acc, opt) => {
    acc[opt.value] = opt.label;
    return acc;
  },
  {} as Record<MasterListType, string>
);

export const MASTER_SECTION_OPTIONS: Array<{ value: '' | MasterListSection; label: string }> = [
  { value: '', label: 'No section' },
  { value: 'per_patient', label: 'Per patient' },
  { value: 'unitized', label: 'Unitized' },
  { value: 'staff_rate', label: 'Staff rate' },
  { value: 'stipend', label: 'Stipend' },
  { value: 'site_fee_required', label: 'Basic site fee (required)' },
  { value: 'site_fee_other_required', label: 'Other fee (required at site)' },
  { value: 'site_fee_other_desired', label: 'Other fee (desired at site)' },
  { value: 'overhead', label: 'Institutional overhead' },
  { value: 'holdback', label: 'Holdback' },
  { value: 'screen_fail', label: 'Screen fail' },
  { value: 'multi_year', label: 'Multi-year studies' },
];

export default MASTER_LIST_TYPE_OPTIONS;
